export function generateCompanyNode(companyName, x, y) {
  return {
    id: companyName,
    position: { x, y },
    data: { label: companyName },
    style: {
      width: 170,
      height: 170,
      borderRadius: "100%",
      background: "white",
      color: "#FF931E",
      fontWeight: "bold",
      borderWidth: 4,
      fontSize: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    type: "input",
  };
}

export function generateGroupingNode(index, x, y) {
  return {
    id: `${index}-groupNode`,
    position: { x, y },
    style: {
      width: 200,
      height: 200,
      background: "none",
      border: "none",
    },
    type: "group",
  };
}

export function generateCategoryNodes(index, category, x, y) {
  return {
    id: `${index}`,
    position: { x, y },
    data: { label: category },
    style: {
      width: 120,
      height: 120,
      background: "#FF931E",
      borderRadius: "50%",
      color: "white",
      borderWidth: 0,
      fontSize: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    type: "default",
  };
}

export function generatePropertyNodes(
  id,
  x,
  y,
  propertyNodeWidth,
  propertyNodeHeight,
  propertyLabel,
  categoryId
) {
  return {
    id: `${categoryId}--${id}`,
    position: { x, y },
    data: {
      label: (
        <div
          style={{
            width: `${propertyNodeWidth}px`,
            height: `${propertyNodeHeight}px`,
          }}
        >
          <div
            dangerouslySetInnerHTML={{ __html: propertyLabel }}
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        </div>
      ),
      categoryId,
    },
    style: {
      width: propertyNodeWidth,
      height: propertyNodeHeight,
      background: "#FF931E",
      color: "white",
      borderRadius: "5%",
      borderWidth: 0,
      fontSize: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    type: "output",
    parentNode: categoryId,
  };
}
